import React, { useEffect, useState } from 'react'

import StudentRaiseHand from './StudentRaiseHand'

import { ASR_EVENTS } from '../StudentASRConstants'
import useStudentPreChecks from '../../useStudentPreChecks'
import PreCheckTeacherModal from '../../Components/PreCheckTeacherModal'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'
import TeacherTestPrompt from './TeacherTestPrompt'
import TeacherTestResultSuccess from './TeacherTestResultSuccess'
import TeacherTestResultFailed from './TeacherTestResultFailed'

export default React.memo(function ASRTeacherModal(props) {

  const { speechProps, handleRetry, studentDidTry, teacherMode, setTeacherMode, successfulTest, hasHighBackgroundNoise, endASRCheck } = props

  const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentASRChecks })
  const [ inTroubleshootView, setInTroubleshootView ] = useState(teacherMode)

  useEffect(() => {

    // log student failures here
    if(!teacherMode){
      studentPreCheck.logEvent(ASR_EVENTS.CALLED_TEACHER)
      if (studentDidTry.current) {
        logStudentModeFailure()
      } else {
          studentPreCheck.logEvent(ASR_EVENTS.STUDENT_NOT_TRYING)
      }
    }

    return () => {
      speechProps.abortSpeech()
    }
  }, [])

  const logStudentModeFailure = () => {
    // background noise is measured for the case of finishing the phrase,
    // but failed because the accuracy is below the passing rate.
    if (hasHighBackgroundNoise){
      studentPreCheck.logEvent(ASR_EVENTS.STUDENT_FAILED_WITH_BG_NOISE)
    }else{
      studentPreCheck.logEvent(ASR_EVENTS.STUDENT_FAILED_WITHOUT_BG_NOISE)
    }
  }
  const teacherRetry = () => {
    if(!teacherMode){
      setTeacherMode(true)
      studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TEST_STARTED)
    }else{
      studentPreCheck.logEvent(ASR_EVENTS.TEACHER_RETRY)
    }
    handleRetry()
  }
  const studentRetry = () => {
    studentPreCheck.logEvent(ASR_EVENTS.STUDENT_RETRY)
    handleRetry()
  }

  if(inTroubleshootView){
    if (!teacherMode) {
      return <TeacherTestPrompt handleRetry={teacherRetry} />
    }

    if (successfulTest) {
      return <TeacherTestResultSuccess 
        speechProps={speechProps} 
        endASRCheck={endASRCheck} 
        hasHighBackgroundNoise={hasHighBackgroundNoise} />
    }

    if (!successfulTest) {
      return <TeacherTestResultFailed 
        speechProps={speechProps} 
        teacherRetry={teacherRetry}
        hasHighBackgroundNoise={hasHighBackgroundNoise} />
    }
  }

  return <PreCheckTeacherModal
    setInTroubleshootView={setInTroubleshootView}
    StudentView={StudentRaiseHand}
    handleRetry={studentRetry}
  />
})
